import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import FormCreator from "../../../../components/forms/FormCreator";
import { OthersData } from "../../data/Others.Data";
import AdditionalQuestions from "./component/AdditionalQuestions/AdditionalQuestions";
import DietaryRequirementForm from "./component/DietaryRequirementForm";


const Others = forwardRef((props, ref) => {
  const otherRef = useRef();
  const additionalQuestionsRef = useRef();

  // Expose method `getFormData` to parent components to retrieve form data from `FormCreator`
  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const otherData = otherRef.current.getFormData();
        return otherData;
      }
      return null;
    }
  }))

  return (
    <div>
      <DietaryRequirementForm />
      <AdditionalQuestions ref={additionalQuestionsRef} />
      <FormCreator
        config={OthersData}
        ref={otherRef}
        key={false}
      />
    </div>
  );
});

export default Others;
